import gql from "graphql-tag"

const CREATE_OR_UPDATE_CUSTOM_GIFT_CARD_CONFIG = gql`
  mutation createOrUpdateBSGGiftCardConfig(
    $id: ID!
    $baseUrl: String!
    $tokenUrl: String!
    $scopes: [String!]!
    $clientId: String!
    $clientSecret: String!
  ) {
    createOrUpdateBSGGiftCardConfig(
      id: $id
      bsgGiftCardConfig: {
        baseUrl: $baseUrl
        tokenUrl: $tokenUrl
        scopes: $scopes
        clientId: $clientId
        clientSecret: $clientSecret
      }
    ) {
      id
    }
  }
`
export default CREATE_OR_UPDATE_CUSTOM_GIFT_CARD_CONFIG
